import {
  trigger,
  state,
  style,
  query,
  group,
  animateChild,
  animate,
  transition,
  // ...
} from '@angular/animations';

export const slideInAnimation =
  trigger('routeAnimations', [
    transition('* <=> *', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 2
        })
      ]),
      query(':enter', [
        style({ left: '-100%'})
      ]),
      query(':leave', animateChild()),
      group([
        query(':leave', [
          animate('500ms ease-out', style({ left: '100%'}))
        ]),
        query(':enter', [
          animate('500ms ease-out', style({ left: '0%', opacity:1}))
        ])
      ]),
      query(':enter', animateChild()),
    ]),
   
  ]);